<template>
  <div class="container">
    <div class="top-bg">
      <!-- <div class="return" @click="linkytowin">
        <span>返回优途</span>
      </div>-->
      <img src="../../static/images/qie01.jpg" alt />
    </div>
    <div class="ct">
      <shaixuan class="saixuan"></shaixuan>
      <div class="test ct-centre">
        <div class="test-top">
          <h2>试听课程</h2>
          <a @click="linkividelist()">更多></a>
        </div>
        <div class="test-ct">
          <ul>
            <li
              class="test-ct-li"
              v-for="(item, index) in indexDataclass"
              :key="index"
              @click="linkivideodetails(item)"
            >
              <div class="class-bg">
                <img
                  class="class-bt"
                  src="../../static/images/class-bt.png"
                  alt
                />
                <div class="class-text">
                  <h5>{{ item.name }}</h5>
                </div>
                <img src="../../static/images/class-bg.png" alt />
              </div>
              <div class="test-ct-text">
                <h3 :title="item.name">{{ item.name }}</h3>
                <div class="text-c">
                  <i>{{ item.teacher }}</i>
                  <span :title="item.tags">{{ item.tags }}</span>
                </div>
                <div class="text-bt">
                  <p>直播上课</p>
                  <p>无限回放</p>
                  <p>1V1辅导</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="introduce ct-centre">
        <div class="introduce-top">
          <h2>老师简介</h2>
          <p @click="linkintroducelist()">更多></p>
        </div>
        <div class="introduce-ct">
          <ul>
            <li
              class="introduce-ct-li"
              v-for="(item, index) in indexDatateachers"
              :key="index"
              @click="linktc(item)"
            >
              <img v-lazy="imgsrc + item.name + '.jpg'" alt />
              <div class="introduce-ct-text">
                <div class="text-c">
                  <i>{{ item.name }}</i>
                  <span>{{ item.grade2 }} · {{ item.sf }}</span>
                </div>
                <div class="text-x">
                  <span :title="item.tags">{{ item.tags }}</span>
                  <p>{{ item.tstag }}</p>
                </div>
                <div class="text-bt">
                  <p>学员数：{{ item.num }}</p>
                  <p>好评率：{{ item.percent }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="qe-bottom ct-centre">
        <div class="qe-bottom-top">
          <h2>企鹅辅导介绍</h2>
          <p href @click="linkqe">更多></p>
        </div>
        <div class="bottom-img" @click="linkqe">
          <img src="../../static/images/qebanner.jpg" alt />
        </div>
      </div>
      <div class="qe-bottom ct-centre">
        <div class="qe-bottom-top">
          <h2>涯礼学堂介绍</h2>
          <!--<p href @click="linkqeT">更多></p>-->
        </div>
        <div class="bottom-img" @click="linkqeT">
          <img src="../../static/images/ylbanner.jpg" alt />
        </div>
      </div>
    </div>
    <floatewm class="floatewm"></floatewm>
  </div>
</template>

<script>
import teacherData from "../../static/json/data.js";
import shaixuan from "../components/shaixuan";
import floatewm from "../components/floatewm";

export default {
  components: {
    shaixuan: shaixuan,
    floatewm: floatewm
  },
  data() {
    return {
      imgsrc: "./static/images/shrink-tc/",
      linkdetils: {},
      linkvideo: {},
      form: [{ text: "试听课程" }, { text: "老师简介" }],
      videosData: teacherData._videosData(),
      indexDataclass: [],
      teachersData: teacherData._teachersData(),
      indexDatateachers: []
    };
  },
  mounted() {
    //  this.$axios({
    //   url: "http://localhost:8080/#/",
    //   method: "get",
    // }).then(res => {
    //   if(res.data.indexOf(`name=viewport`) != -1){
    //   console.log("有");
    //   }
    //   else{
    //   console.log("没有");
    //   window.location.href = "http://www.ytowin.com/passport/login";
    //   }
    // });

    // this.$axios({
    //   url: "http://www.ytowin.com/account/activation",
    //   method: "get"
    // }).then(res => {
    //   console.log(res.data);
    //   if (
    //     res.data.indexOf(
    //       `<input class="card_t" value="A7019E5C-CEA2-4A05-B5CA-3565AC6D8D38" type="hidden" />`
    //     ) != -1
    //   ) {
    //     console.log("有权限");
    //   } else {
    //     console.log("没有权限");
    //     window.location.href = "http://www.ytowin.com/passport/login";
    //   }
    // });
    /* 过滤出只有高中的课程视频和老师 */
    let newVideosData = this.videosData.filter((item, index) => {
      return (
        item.grade == "高一" || item.grade == "高二" || item.grade == "高三"
      );
    });
    let newteachersData = this.teachersData.filter((item, index) => {
      return (
        item.grade == "高一" || item.grade == "高二" || item.grade == "高三"
      );
    });
    for (var i = 0; 4 > i; i++) {
      this.indexDataclass.push(
        newVideosData[Math.floor(Math.random() * newVideosData.length + 0)]
      );
      Math.floor(Math.random() * 10 + 1);
    }

    for (var i = 0; 4 > i; i++) {
      this.indexDatateachers.push(
        newteachersData[Math.floor(Math.random() * newteachersData.length + 0)]
      );
    }
  },
  methods: {
    //教师详情
    linktc(item) {
      this.linkdetils = item;
      localStorage.setItem("linkdetils", JSON.stringify(this.linkdetils));
      this.$router.push({
        path: "/details",
        query: {
          data: this.linkdetils
        }
      });
    },

    linkqe() {
      this.$router.push({
        path: "/penguin"
      });
    },
    //教师更多
    linkintroducelist() {
      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: 0,
          gradecurrent: 0,
          subjectcurrent: 0,
          datescurrent: 0,
          formcurrent: 1,
          link: "/introducelist",
          data: {
            classify: "高中",
            grade: "全部",
            subject: "全部",
            dates: "全部"
          }
        })
      );
      this.$router.push({
        path: "/introducelist"
      });
    },
    //试听详情
    linkivideodetails(item) {
      this.linkvideo = item;
      localStorage.setItem("linkvideo", JSON.stringify(this.linkvideo));
      this.$router.push({
        path: "/videodetails",
        query: {
          data: this.linkvideo
        }
      });
    },
    //试听课更多
    linkividelist() {
      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: 0,
          gradecurrent: 0,
          subjectcurrent: 0,
          datescurrent: 0,
          formcurrent: 0,
          link: "/videolist",
          data: {
            classify: "高中",
            grade: "全部",
            subject: "全部",
            dates: "全部"
          }
        })
      );
      this.$router.push({
        path: "/videolist"
      });
    },
    linkytowin() {
      window.location.href = "http://www.ytowin.com/";
    },
    linkqeT() {
      window.open("http://www.huikt.cn/#/");
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1200px;
  .ct {
    width: 100%;
    margin: 20px auto;
  }
  .top-bg {
    .return {
      width: 1200px;
      margin: 0 auto;
      /*  position: absolute;*/
      position: relative;
      span {
        cursor: pointer;
        left: 97%;
        top: -15px;
        padding: 95px 7px 5px 7px;
        color: #fff;
        text-align: center;
        width: 30px;
        height: 160px;
        position: absolute;
        background: url("../../static/images/return.png") no-repeat;
        background-size: 100%;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      span:hover {
        top: 0px;
      }
    }
    > img {
      width: 100%;
      min-width: 1200px;
    }
  }
  .test {
    width: 1200px;
    margin-top: 100px;
    .test-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 44px;
      > h2 {
        width: 123px;
        height: 30px;
        font-size: 30px;
        font-weight: bold;
        color: #333333;
      }
      > a {
        cursor: pointer;
        width: 45px;
        height: 17px;
        font-size: 16px;
        color: #666666;
        opacity: 0.6;
      }
    }
    .test-ct {
      ul {
        display: flex;
        justify-content: space-between;
        .test-ct-li {
          cursor: pointer;
          width: 286px;
          height: 304px;
          .class-bg {
            position: relative;
            .class-bt {
              z-index: 11;
              width: 48px;
              height: 48px;
              top: 50%;
              left: 50%;
              margin-left: -24px;
              margin-top: -24px;
              opacity: 0.3;
              position: absolute;
            }
            .class-text {
              position: absolute;
              display: flex;
              align-items: center;
              width: 100%;
              height: 100%;
            }
            h5 {
              margin-left: 22px;
              width: 126px;
              font-size: 14px;
              font-weight: normal;
              color: #ffffff;
              opacity: 0.9;
            }
            > img {
              display: block;
              width: 286px;
              height: 166px;
              background-color: #52c65f;
              border-radius: 4px 4px 0px 0px;
            }
          }

          .test-ct-text {
            box-sizing: border-box;
            padding: 16px 10px;
            width: 286px;
            height: 140px;
            background-color: #ffffff;
            box-shadow: 0px 1px 6px 0px rgba(18, 179, 117, 0.26);
            border-radius: 0px 0px 4px 4px;

            > h3 {
              width: 265px;
              height: 25px;
              font-size: 22px;
              font-weight: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .text-c {
              margin-top: 20px;
              height: 28px;
              display: flex;
              align-items: flex-end;
              > i {
                margin-right: 13px;
                font-style: normal;
                width: 54px;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
              }
              > span {
                display: inline-block;
                width: 196px;
                font-size: 14px;
                font-weight: normal;
                letter-spacing: 0px;
                color: #999999;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .text-bt {
              display: flex;
              margin-top: 12px;
              p {
                margin-right: 32px;
                width: 48px;
                height: 12px;
                font-size: 12px;
                line-height: 30px;
                letter-spacing: 0px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
  .introduce {
    margin-top: 126px;
    width: 1200px;
    height: 100%;
    .introduce-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 44px;
      > h2 {
        width: 123px;
        height: 30px;
        font-size: 30px;
        font-weight: bold;
        color: #333333;
      }
      > p {
        cursor: pointer;
        width: 45px;
        height: 17px;
        font-size: 16px;
        color: #666666;
        opacity: 0.6;
      }
    }
    .introduce-ct {
      ul {
        display: flex;
        justify-content: space-between;
        .introduce-ct-li {
          cursor: pointer;
          width: 286px;
          height: 334px;
          > img {
            display: block;
            width: 286px;
            height: 166px;
            background-color: #52c65f;
            border-radius: 4px 4px 0px 0px;
          }
          .introduce-ct-text {
            box-sizing: border-box;
            padding: 16px 10px;
            width: 286px;
            height: 160px;
            background-color: #ffffff;
            box-shadow: 0px 1px 6px 0px rgba(18, 179, 117, 0.26);
            border-radius: 0px 0px 4px 4px;

            .text-c {
              > i {
                margin-right: 13px;
                font-style: normal;
                width: 54px;
                height: 18px;
                font-size: 18px;
                font-weight: normal;
                line-height: 24px;
                letter-spacing: 0px;
                color: #333333;
              }
              font-size: 14px;
              font-weight: normal;
              color: #999999;
            }
            .text-x {
              margin-top: 24px;
              font-size: 14px;
              letter-spacing: 0px;
              color: #333333;
            }
            .text-bt {
              display: flex;
              margin-top: 12px;

              p {
                margin-right: 32px;
                height: 12px;
                font-size: 12px;
                line-height: 30px;
                letter-spacing: 0px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
  .qe-bottom {
    margin-top: 126px;
    margin-bottom: 92px;
    width: 1200px;
    .qe-bottom-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 44px;
      > h2 {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
      }
      > p {
        cursor: pointer;
        width: 45px;
        height: 17px;
        font-size: 16px;
        color: #666666;
        opacity: 0.6;
      }
    }
    .bottom-img {
      border-radius: 15px;
      overflow: hidden;
      cursor: pointer;
      width: 1200px;
      img {
        width: 100%;
      }
    }
  }
  .floatewm {
    z-index: 99;
    position: fixed;
    right: 17px;
    top: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue